export default __webpack_public_path__ + "static/media/ACID-REFLUX.1c836605.png";